<div class="questionnaire-head-photo-layout">
  <img src="{{origin}}{{questionnaireHeadPhotoUrlArray[questionnaireLevel].description}}" alt="" />
</div>



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-head-photo/questionnaire-head-photo.component.html